import { ApiError } from "./client";
import { ApiErrorKeys } from "../constants/apiErrorKeys";
import { HTTP_STATUS_BAD_GATEWAY, HTTP_STATUS_FORBIDDEN, HTTP_STATUS_GATEWAY_TIMEOUT, HTTP_STATUS_SERVICE_UNAVAILABLE } from "../constants/httpStatus";

/** Wenn ein API-Aufruf 403 + TenantImportCommitInProgress liefert, aber kein Caller das Promise abfängt. */
export const TENANT_IMPORT_COMMIT_BLOCKED_EVENT = "app-tenant-import-commit-blocked";

export function parseTenantImportCommitErrorKeyFromBody(bodyText: string): string | undefined {
  try {
    const j = JSON.parse(bodyText || "{}") as { errorKey?: string; ErrorKey?: string };
    const k = j.errorKey ?? j.ErrorKey;
    return typeof k === "string" ? k : undefined;
  } catch {
    return undefined;
  }
}

/** Erwarteter Mandanten-Sperrzustand während Admin-Datenimport (Commit), kein Anwendungsfehler. */
export function isTenantImportCommitBlockedApiError(reason: unknown): boolean {
  if (!(reason instanceof ApiError) || reason.status !== HTTP_STATUS_FORBIDDEN) return false;
  return parseTenantImportCommitErrorKeyFromBody(reason.bodyText ?? "") === ApiErrorKeys.TenantImportCommitInProgress;
}

/** Erwartete transiente Wartung während Deploy/Restart (nginx 502/504, MigrationGate 503) — kein Fehler-Overlay. */
export function isBackendUnreachableApiError(reason: unknown): boolean {
  if (!(reason instanceof ApiError)) return false;
  return reason.status === HTTP_STATUS_BAD_GATEWAY || reason.status === HTTP_STATUS_SERVICE_UNAVAILABLE || reason.status === HTTP_STATUS_GATEWAY_TIMEOUT;
}
